import { TokenResponse } from "@react-oauth/google";
import { backendApi } from "../api";

// Define the new endpoints
const userEndpoints = backendApi.injectEndpoints({
  endpoints: (builder) => ({
    googleSignIn: builder.mutation<{ token: string }, TokenResponse>({
      query: (data) => {
        return { url: "/auth/google", method: "POST", data };
      },
      // invalidatesTags: [{ type: "Users", id: "LIST" }],
    }),
  }),
});

// Export the hooks for the new endpoints
export const { useGoogleSignInMutation } = userEndpoints;
